import { SvgIcon } from '@progress/kendo-react-common';
import { Switch } from '@progress/kendo-react-inputs';
import React, { useEffect } from 'react';
import { WarningTriangleOutline } from '../../../../../icons/icons';
import { getDirectoryDb } from '../../../../../services/directory-db';
import { MapAutoScreenshotTargetOptions } from '../../../../../types/dropdown-options';
import { MapAutoScreenshotTarget } from '../../../../../types/settings';
import { DropdownListWithValueField } from '../../../../components/inputs/DropdownListWithValueField';
import MarkerText from '../../../../components/inputs/MarkerText';
import { useEvent } from '../../../../contexts/event-bus';
import { useAppSelector } from '../../../../hooks/store-hooks';
import { useSettingDropdownValue, useSettingSwitchValue } from '../../../home/hooks/settings';
import { MAP_INDEXEDDB_KEY } from '../../../home/layers/MapScreenshot';
import { useSearchContext } from '../../context/SettingsSearchContext';

export function SettingsAutoScreenshotElement() {
    const hasRights = useAppSelector((x) => x.user.rights.webSnapshot);
    if (!hasRights) {
        return null;
    }

    return <Component />;
}

function Component() {
    const context = useSearchContext();
    const enabled = useSettingSwitchValue('mapImageAutoSlideShow');
    const type = useSettingDropdownValue(MapAutoScreenshotTargetOptions, 'mapImageAutoSlideShowTarget');
    const uploadServerUrlSet = !!useAppSelector((x) => x.settings.mapImageServerUrl);
    const [screenshotDirectorySet, setScreenshotDirectorySet] = React.useState(true);
    const [dirChangeIndx, setDirChangeIndx] = React.useState(0);

    useEffect(() => {
        (async () => {
            const db = await getDirectoryDb();
            const folderHandle = (await db.get('file-handles', MAP_INDEXEDDB_KEY)) as FileSystemDirectoryHandle | undefined;
            const folderHandleValid =
                folderHandle &&
                folderHandle.kind === 'directory' &&
                (await folderHandle.queryPermission({ mode: 'readwrite' })) === 'granted';
            setScreenshotDirectorySet(folderHandleValid === true);
        })();
    }, [dirChangeIndx]);

    useEvent('file-handle-changed', (e) => {
        if (e === MAP_INDEXEDDB_KEY) {
            setDirChangeIndx((x) => x + 1);
        }
    });

    return (
        <div className="px-3 py-2">
            <div className="d-flex align-items-center gap-2">
                <div className="flex-grow-1">
                    <MarkerText highlight={context.term}>Take a screenshot automatically in slide show mode</MarkerText>
                </div>

                <div style={{ width: 250 }}>
                    <DropdownListWithValueField {...type} />
                </div>

                <Switch {...enabled} />
            </div>

            {enabled.checked && (
                <div className=" text-warning">
                    {(type.value & MapAutoScreenshotTarget.upload) !== 0 && !uploadServerUrlSet && (
                        <div className="d-flex align-items-center gap-1">
                            <SvgIcon icon={WarningTriangleOutline} />
                            <span>Upload server url not set</span>
                        </div>
                    )}

                    {(type.value & MapAutoScreenshotTarget.file) !== 0 && !screenshotDirectorySet && (
                        <div className="d-flex align-items-center gap-1">
                            <SvgIcon icon={WarningTriangleOutline} />
                            <span>Default folder not set</span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
